
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-recovery/request",
      function () {
        return require("private-next-pages/password-recovery/request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password-recovery/request"])
      });
    }
  